exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-selectGroup{display:inline-block;max-width:100%}.ba-common-selectGroup.is-left{text-align:left}.ba-common-selectGroup.is-right{text-align:right}.ba-common-selectGroup__item{display:block}.ba-common-selectGroup__item:not(:last-child){margin-bottom:16px}", ""]);

// exports
exports.locals = {
	"selectGroupClassName": "\"ba-common-selectGroup\""
};